const initialState = { 
  loading: false,
  success: null,
  error: null
}

function saveBannerReducer(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_BANNER_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'SAVE_BANNER_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'SAVE_BANNER_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default saveBannerReducer